import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        console.log('AuthCallback: Processing auth callback...');
        
        // Check for error in URL parameters
        const params = new URLSearchParams(window.location.search);
        const errorMessage = params.get('error_description');
        
        if (errorMessage) {
          console.log('AuthCallback: Error detected:', errorMessage);
          navigate('/login', {
            state: { message: decodeURIComponent(errorMessage) },
            replace: true
          });
          return;
        }

        // For any other case, let the AuthContext handle the session
        // and redirect appropriately
        console.log('AuthCallback: No error detected, redirecting to home');
        navigate('/', { replace: true });
        
      } catch (error) {
        console.error('AuthCallback: Unexpected error:', error);
        navigate('/login', { replace: true });
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <Loader2 className="mx-auto h-12 w-12 text-blue-500 animate-spin" />
        <h2 className="mt-6 text-xl font-semibold text-gray-900">
          Processing authentication...
        </h2>
        <p className="mt-2 text-sm text-gray-600">
          Please wait while we complete your sign-in.
        </p>
      </div>
    </div>
  );
}